import { Controller } from "@hotwired/stimulus";
import Chart from "chart.js/auto";

export default class extends Controller {
  static targets = ["paymentChart", "thisMonthChart"];

  static values = {
    paidTowardsLoan: Number,
    paidTowardsInterest: Number,
    monthlyPrincipal: Number,
    monthlyInterest: Number,
  };

  connect() {
    this.renderChart(
      this.paymentChartTarget,
      [this.paidTowardsLoanValue, this.paidTowardsInterestValue],
      ["Paid towards loan", "Paid towards interest"],
    );

    this.renderChart(
      this.thisMonthChartTarget,
      [this.monthlyPrincipalValue, this.monthlyInterestValue],
      ["Monthly principal", "Monthly interest"],
    );
  }

  renderChart(canvas, data, labels) {
    const ctx = canvas.getContext("2d");

    const primaryColor = getComputedStyle(document.documentElement)
      .getPropertyValue("--primary-color-50")
      .trim();
    const primaryColorDark = getComputedStyle(document.documentElement)
      .getPropertyValue("--primary-color")
      .trim();

    const chart = new Chart(ctx, {
      type: "pie",
      data: {
        labels,
        datasets: [
          {
            data,
            backgroundColor: [primaryColorDark, primaryColor],
            borderWidth: 0,
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: true,
        plugins: {
          legend: { display: false },
          tooltip: { enabled: false },
        },
      },
    });

    return chart;
  }
}
